export default __webpack_public_path__ + "static/media/leoescalade.a0848ad8.png";